export default __webpack_public_path__ + "static/media/Screenshot_20210828-083538.428e650a.png";